import React, { useCallback } from 'react';
import Link from '../../../Router/Link';
import { IButton } from '.';

interface IHeroButton extends React.ComponentProps<typeof Link> {
  button: IButton;
  trackClickHandler: (text: string, url: string) => void;
}

export const HeroButton = ({ trackClickHandler, button, ...props }: IHeroButton) => {
  const handleBeforeNavigate = useCallback(() => {
    trackClickHandler(button.text, button.url);
  }, [trackClickHandler, button]);

  return (
    <Link {...props} onBeforeNavigate={handleBeforeNavigate}>
      {button.text}
    </Link>
  );
};
